import { RefObject } from 'react';
import { BoxContextValue } from '../FeatureAppTypes';

export const getBoundingClient = <T extends HTMLElement>(ref: RefObject<T>): BoxContextValue => {
  if (ref.current && ref.current?.getBoundingClientRect) {
    const { top, left, width, height } = ref.current.getBoundingClientRect();
    return { top, left, width, height };
  }

  return { top: 0, left: 0, width: 0, height: 0 };
};
